"use client";

import Link from "next/link";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/auth-context";

// TODO: total coupon count and discount tier copy should come from API.
const TOTAL_COUPONS = 4;
const ORDINALS = ["1er", "2do", "3er"];
const SPANISH_MONTHS = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

function getCouponBaseName(): string {
  const now = new Date();
  const month = SPANISH_MONTHS[now.getMonth()].toUpperCase();
  const year = String(now.getFullYear()).slice(-2);
  return `${month}${year}`;
}

const DISCOUNT_TIERS_COPY =
  "mayor a $800 ($50 OFF), $1,200 ($80 OFF), $1,500 ($100 OFF), $2,250 ($150 OFF), $3,000 ($200 OFF) o $4,000 ($250 OFF)";

type Props = {
  onClose: () => void;
};

export default function CaliiPlusMemberModalContent({ onClose }: Props) {
  const { user } = useAuth();
  const remaining = user?.num_remaining_calii_plus_coupons ?? 0;
  const baseName = getCouponBaseName();

  const coupons = Array.from({ length: TOTAL_COUPONS }, (_, i) => ({
    ordinal: ORDINALS[i],
    code: i === 0 ? baseName : `${baseName}-${i + 1}`,
  }));

  return (
    <div className="flex flex-col flex-1 min-h-0">
      {/* Scrollable body */}
      <div className="flex-1 overflow-y-auto">
        {/* Header */}
        <div className="flex items-center gap-3 px-4 py-3">
          <button type="button" onClick={onClose} className="text-teal-500 shrink-0">
            <X className="h-5 w-5" />
          </button>
          <span className="font-semibold text-base">$1000 de regalo al mes y envíos gratis</span>
        </div>

        {/* Edge-to-edge image */}
        {/* TODO: image URL should come from API */}
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src="https://caliiorderissues.s3.us-east-2.amazonaws.com/calii_plus_1000.jpg"
          alt="Calii+ — $1000 de regalo y envíos gratis"
          className="w-full"
        />

        {/* Body */}
        {/* TODO: body copy should come from API */}
        <div className="px-4 pt-4 pb-6 space-y-4 text-sm">
          <p>
            Por ser miembro Calii+, recibe $1000 de regalo cada mes, envíos gratis ilimitados en pedidos mayores a $300, promos exclusivas y más.
          </p>
          {coupons.map(({ ordinal, code }) => (
            <p key={code}>
              Hasta $250 de regalo en tu {ordinal} pedido al mes {DISCOUNT_TIERS_COPY}.{" "}
              <span className="font-semibold">Código: {code}</span>
            </p>
          ))}
          <p>Los códigos se agregarán automáticamente en el checkout. Códigos válidos hasta fin de mes.</p>
          <p>Te quedan <span className="font-semibold">{remaining}/4</span> regalos este mes</p>
        </div>
        
      </div>

      {/* Pinned footer */}
      <div className="border-t px-4 pt-4 pb-6 space-y-2 shrink-0">
        <Button variant="outline" className="w-full cursor-pointer" size="lg" asChild>
          <Link href="/cuenta/membresia" onClick={onClose}>Ver membresía</Link>
        </Button>
        <Button variant="outline" className="w-full cursor-pointer" size="lg" onClick={onClose}>
          Cerrar
        </Button>
      </div>
    </div>
  );
}
